import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';
import { useAuth } from './context/AuthContext';

// Pages
import AdminDashboard from './pages/SuperAdmin/Dashboard';
import AdminSettings from './pages/SuperAdmin/Settings';
import MasterDashboard from './pages/Master/Dashboard';
import DropsConfig from './pages/Master/DropsConfig';
import PilotManagement from './pages/Master/PilotManagement';
import PilotDiscovery from './pages/Master/PilotDiscovery'; // New Import
import MasterActivity from './pages/Master/Transactions';
import Payouts from './pages/Master/Payouts';
import PilotDashboard from './pages/Pilot/Dashboard';
import LogDrops from './pages/Pilot/LogDrops';
import PublicFeeds from './pages/PublicFeeds';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" />;
  return children;
};

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/feeds" element={<PublicFeeds />} />
      <Route element={<Layout />}>
        {/* Super Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/discovery" element={<ProtectedRoute allowedRoles={['super_admin']}><PilotDiscovery /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminSettings /></ProtectedRoute>} />

        {/* Master Routes */}
        <Route path="/master" element={<ProtectedRoute allowedRoles={['master']}><MasterDashboard /></ProtectedRoute>} />
        <Route path="/master/pilots" element={<ProtectedRoute allowedRoles={['master']}><PilotManagement /></ProtectedRoute>} />
        <Route path="/master/discovery" element={<ProtectedRoute allowedRoles={['master']}><PilotDiscovery /></ProtectedRoute>} />
        <Route path="/master/activity" element={<ProtectedRoute allowedRoles={['master']}><MasterActivity /></ProtectedRoute>} />
        <Route path="/master/drops" element={<ProtectedRoute allowedRoles={['master']}><DropsConfig /></ProtectedRoute>} />
        <Route path="/master/payouts" element={<ProtectedRoute allowedRoles={['master']}><Payouts /></ProtectedRoute>} />

        {/* Pilot Routes */}
        <Route path="/pilot" element={<ProtectedRoute allowedRoles={['pilot']}><PilotDashboard /></ProtectedRoute>} />
        <Route path="/pilot/log" element={<ProtectedRoute allowedRoles={['pilot']}><LogDrops /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Route>
    </Routes>
  );
};

export default App;